// ============================================
// config/firebase.js - Configuração do Firebase
// Scriptus Pharma Partner
// 
// ✅ browserSessionPersistence: Sessão encerra ao fechar navegador
// ✅ Mantém todas as exportações originais
// ============================================

import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Auth
const auth = getAuth(app);

// ✅ CONFIGURA PERSISTÊNCIA DE SESSÃO
// browserSessionPersistence = Sessão dura apenas enquanto a aba/navegador estiver aberto
// Ao fechar o navegador completamente, o usuário será deslogado
// Isso é mais seguro para computadores compartilhados em farmácias
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log('🔒 Firebase Auth: Persistência configurada para SESSION');
  })
  .catch((error) => {
    console.error('❌ Erro ao configurar persistência:', error);
  });

// Inicializa Firestore
const db = getFirestore(app);

// Inicializa Storage
const storage = getStorage(app);

// Exporta serviços
export { auth, db, storage };

export default app;